import '../scss/pages/lotissements.scss';
import 'leaflet/dist/leaflet.css'

import L from 'leaflet';

jQuery(function ($) {
    const LIST_SIZE = 20; // configuration for list size

    let CURRENT_ITEM_POSITION = 0; // Current position of cursor
    let SHOW_MORE = false; // flag to show/hide btn Load More

    // List data JSON for FE
    let CURRENT_LOTISSEMENT_ITEMS = [];

    const map = L.map("map_leaflet", {
        center: [-17.53338, -149.55398],
        zoom: 12,
        scrollWheelZoom: false,
        zoomControl: false // Remove default zoom Control
    });

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: ""
    }).addTo(map);

    // Add custom zoom Control to bottom-right
    L.control
        .zoom({
            position: "bottomright"
        })
        .addTo(map);

    // Add custom layerGroup
    const layerGroup = L.layerGroup().addTo(map);

    // Select list container html
    const LIST_CONTAINER = $(".map-control-panel .lotissements__list");

    // Init
    $(".city-filter").select2({
        placeholder: "Communes"
    }); // Init Select2

    // Clone list items array, prevent change raw data
    CURRENT_LOTISSEMENT_ITEMS = [...LIST_LOTISSEMENT_ITEMS];

    // Check width of device
    let WINDOW_WIDTH = $(window).width();
    initList();

    $(window).on("resize", function () {
        let newWidth = $(window).width();

        if (newWidth != WINDOW_WIDTH) {
            WINDOW_WIDTH = newWidth;

            CURRENT_ITEM_POSITION = 0;
            initList();

        }

    });

    function initList() {
        if (WINDOW_WIDTH > 767) {
            renderListToMap(CURRENT_LOTISSEMENT_ITEMS, true); // render all list

        } else {
            checkAndRenderItems(true);

            // Add trigger for btn Load More
            $(".map-control-panel").on(
                "click",
                ".btn-loadmore", () => {
                    checkAndRenderItems(atrue);
                });
        }
    }

    /**
     * Function check and generate list for Mobile (5 items)
     */
    function checkAndRenderItems(replaceCurrentList) {
        let nextPos = getkNextPosition();

        let listItems = getNextList(CURRENT_LOTISSEMENT_ITEMS, nextPos);  // Generate list
        renderListToMap(listItems, replaceCurrentList); // render next items

        CURRENT_ITEM_POSITION = nextPos; //update position
        if (SHOW_MORE) {
            $('.mobile-loadmore').addClass('show');
        } else {
            $('.mobile-loadmore').removeClass('show');
        }
    }

    /**
     * Helper get next position from list
     */
    function getkNextPosition() {
        let nextPost = CURRENT_ITEM_POSITION + LIST_SIZE; // check next position
        if (nextPost < CURRENT_LOTISSEMENT_ITEMS.length) {
            SHOW_MORE = true;
            return nextPost;
        } else {
            SHOW_MORE = false;
            return CURRENT_LOTISSEMENT_ITEMS.length;
        }
    }

    function getNextList(currentPos, nextPos) {
        let nextList = CURRENT_LOTISSEMENT_ITEMS.slice(currentPos, nextPos);
        return nextList;
    }


    $(".city-filter").on("change", function (event) {
        let _this = $(this);
        let value = _this.val();
        if (value === 'toutes') value = '';

        layerGroup.clearLayers(); // clear all current makers
        if (!!value) {
            let filterList = LIST_LOTISSEMENT_ITEMS.filter((element) => {
                return element.city == value;
            });

            if (!!filterList && filterList.length > 0) {
                // render filter list
                CURRENT_LOTISSEMENT_ITEMS = [...filterList];
                if (WINDOW_WIDTH > 767) {
                    // not phone
                    renderListToMap(CURRENT_LOTISSEMENT_ITEMS, true);
                } else {
                    // phone
                    checkAndRenderItems(true);
                }
            }
        } else {
            // No Filter

            CURRENT_LOTISSEMENT_ITEMS = [...LIST_LOTISSEMENT_ITEMS];
            if (WINDOW_WIDTH > 767) {
                // not phone
                renderListToMap(CURRENT_LOTISSEMENT_ITEMS, true);
            } else {
                // phone
                checkAndRenderItems(true);
            }
        }
    });

    const sectionDetail = $(".section-detail");

    // Bind event click for Item Name
    $(".map-control-panel").on("click", ".lotissements__list .lotissements__item .btn-link", function () {
            let _this = $(this);

            $(".lotissements__item").removeClass("active");
            _this.closest(".lotissements__item").addClass("active");
            let item_id = _this.attr("data-id") || "";

            let rs = LIST_LOTISSEMENT_ITEMS.find((element) => {
                return element.id == item_id;
            });

            if (!!rs) {
                var item_lat = rs.position[0] || "";
                var item_lng = rs.position[1] || "";

                map.flyTo({lat: item_lat, lng: item_lng}); // move to position

                // show popup
                var popup = L.popup()
                    .setLatLng([item_lat, item_lng])
                    .setContent(rs.title)
                    .openOn(map);
            }
        }
    );

    // Bind event click for Item '+' btn
    $(".map-control-panel").on(
        "click",
        ".btn-detail",
        function () {

            var _this = $(this);
            let item_id = _this.attr("data-id") || "";

            let rs = LIST_LOTISSEMENT_ITEMS.find((element) => {
                return element.id == item_id;
            });

            if (!!rs) {
                $(sectionDetail).addClass("show");
                $(sectionDetail)
                    .find(".place-title")
                    .text(rs.title);
                $(sectionDetail)
                    .find(".place-description")
                    .text(rs.description);
                $(sectionDetail)
                    .find(".place-content")
                    .html(rs.content);

                const deviceWidth = $(window).width();
                if (deviceWidth < 767) {

                    $('.lotissements-page').addClass('show-detail');
                    $([document.documentElement, document.body]).animate(
                        {
                            scrollTop: $("body").offset().top
                        },
                        200
                    );
                } else {
                    $([document.documentElement, document.body]).animate(
                        {
                            scrollTop: $("#section_detail").offset().top
                        },
                        200
                    );
                }
            }
        }
    );

    // bind event click for close Section Detail
    $(".section-detail").on("click", ".btn-close", function () {
        $(".section-detail").removeClass("show");

        $('.lotissements-page').removeClass('show-detail');
    });

    function moveToPlace(latlng) {
        let rs = CURRENT_LOTISSEMENT_ITEMS.find((element) => {
            return element.position[0] == latlng.lat && element.position[1] == latlng.lng;
        });
        if (!!rs) {
            let btn = $(`.btn-link[data-id="${rs.id}"]`);
            let item = $(btn).closest('.lotissements__item');

            let _first = $('.lotissements__item')[0];
            let _firstTop = $(_first).offset().top;

            if (WINDOW_WIDTH > 767) {
                let top = $(item).offset().top;
                let offsetTop = top - _firstTop;

                $(btn).click();
                setTimeout(() => {
                    LIST_CONTAINER.getNiceScroll(0).doScrollTop(offsetTop, 300);
                }, 300)
            } else {
                $(item).remove(); // remove curret HTML
                LIST_CONTAINER.prepend(item); // prepend to top
                setTimeout(() => {
                    $(btn).trigger('click');
                }, 100)
            }
        }
    }

    function renderListToMap(listJSON, replaceCurrentList) {
        let listHTML = "";

        var blueIcon = L.icon({
            iconUrl: '/build/images/marker-icon.2273e3d8.png',
            shadowUrl: '/build/images/marker-shadow.png',
            iconSize: [25, 41], // size of the icon
            shadowSize: [41, 41], // size of the shadow
            iconAnchor: [25, 41], // point of the icon which will correspond to marker's location
        });

        for (var x = 0; x < listJSON.length; x++) {
            var lat = listJSON[x].position[0] || "";
            var lng = listJSON[x].position[1] || "";
            var title_marker = listJSON[x].title || "";
            var description = listJSON[x].description || "";
            var place_id = listJSON[x].id || "";

            // L.marker([lat, lng]).addTo(map).bindPopup(title_marker);

            let maker = L.marker([lat, lng], {icon: blueIcon})
                .addTo(layerGroup)
                .bindPopup(title_marker);

            maker.on('click', function (event) {
                moveToPlace(event.latlng);
            })

            let itemHTML = "";
            itemHTML = `<li class="lotissements__item"><div class="information"><h2>${title_marker}</h2><p>${description}</p><a class="btn-link link_cover" data-id="${place_id}"  href="javascript:void(0)"></a></div><a class="btn-detail" data-id="${place_id}" href="javascript:void(0)"><i class="icon-plus-border"></i></a></li>`;
            listHTML += itemHTML;
        }

        // Render to HTML
        if (replaceCurrentList) {
            LIST_CONTAINER.html(listHTML)
        } else {
            LIST_CONTAINER.append(listHTML);

        }

        if (WINDOW_WIDTH > 767) {
            LIST_CONTAINER.niceScroll();
        }
    }

});
